import { apiClient } from './apiClient';

export const pmScheduleService = {
  // Get all PM schedules
  async getSchedules() {
    return apiClient.get(`/api/cmms/pm-schedules`);
  },

  // Get PM schedules by status
  async getSchedulesByStatus(status) {
    return apiClient.get(`/api/cmms/pm-schedules/status/${status}`);
  },

  // Get PM schedules by type (INTERNAL/EXTERNAL)
  async getSchedulesByType(type) {
    return apiClient.get(`/api/cmms/pm-schedules/type/${type}`);
  },

  // Get PM schedules for an asset
  async getSchedulesByAsset(assetId) {
    return apiClient.get(`/api/cmms/pm-schedules/asset/${assetId}`);
  },

  // Get upcoming PM schedules
  async getUpcomingSchedules(days = 7) {
    return apiClient.get(`/api/cmms/pm-schedules/upcoming?days=${days}`);
  },

  // Get overdue PM schedules
  async getOverdueSchedules() {
    return apiClient.get(`/api/cmms/pm-schedules/overdue`);
  },

  // Get single PM schedule by ID
  async getScheduleById(id) {
    return apiClient.get(`/api/cmms/pm-schedules/${id}`);
  },

  // Get PM schedule history
  async getScheduleHistory(id) {
    return apiClient.get(`/api/cmms/pm-schedules/${id}/history`);
  },

  // Create new PM schedule
  async createSchedule(data) {
    return apiClient.post(`/api/cmms/pm-schedules`, data);
  },

  // Update PM schedule
  async updateSchedule(id, data) {
    return apiClient.put(`/api/cmms/pm-schedules/${id}`, data);
  },

  // Update PM schedule status (pause/activate)
  async updateScheduleStatus(id, status) {
    return apiClient.put(`/api/cmms/pm-schedules/${id}/status?status=${status}`);
  },

  // Manually trigger PM generation for a single schedule
  async triggerGeneration(id) {
    return apiClient.post(`/api/cmms/pm-schedules/${id}/generate`);
  },

  // Process all due PM schedules (manually trigger the scheduler)
  async processDueSchedules() {
    return apiClient.post(`/api/cmms/pm-schedules/process-due`);
  },

  // Get all due PM schedules (for debugging)
  async getDueSchedules() {
    return apiClient.get(`/api/cmms/pm-schedules/due`);
  },

  // Delete PM schedule
  async deleteSchedule(id) {
    return apiClient.delete(`/api/cmms/pm-schedules/${id}`);
  },
};
